module.exports = new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://mais-precoce-gantt.alpha.agro.rocks/remoteEntry.js";
        script.onload = () => {
          const module = {
            get: (request) => window["pluginGantt"].get(request),
            init: (arg) => {
              try {
                return window["pluginGantt"].init(arg);
              } catch (e) {
                console.log("Problem loading remote pluginGantt", e);
              }
            },
          };
          resolve(module);
        };
        script.onerror = () => {
  const module = {
    get: () => () => {},
    init: () => () => {},
  };
  resolve(module);
}
        document.head.appendChild(script);
      });